import React, {useState} from 'react';
import * as Sentry from "@sentry/react";
import Hotjar from '@hotjar/browser';
import { Crisp } from "crisp-sdk-web";

import './App.css';
import {Invoice} from "./utils";
import Dropzone from "./Dropzone";
import BondDisplayComponent from "./BondDisplayComponent";
import FooterComponent from "./FooterComponent";

Sentry.init({
  dsn: "https://b787adbd1bcc99be4745b0724bcb12a7@o361683.ingest.us.sentry.io/4507085404110848",
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration(),
  ],
  // Performance Monitoring
  tracesSampleRate: 1.0, //  Capture 100% of the transactions
  // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
  tracePropagationTargets: ["localhost", /^https:\/\/yourserver\.io\/api/],
  // Session Replay
  replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
  replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
});

const siteId = 4943799;
const hotjarVersion = 6;
Hotjar.init(siteId, hotjarVersion);

const crispWebsiteId = "183d1169-5af8-4503-aaf6-c083526f1429";
Crisp.configure(crispWebsiteId);

function App() {

  const [parsedResult, setParsedResult] = useState<Invoice>();

  return (
    <div className="App">
      <div className="App-main">
        <div>
          <h1>Bond Extractor</h1>
        </div>
        <div>
          <p className="description">
            We support PDF documents<br/>
            And images as JPEG or PNG <br/>
            so screenshots or photos of an impact report will work as well
          </p>
        </div>
        <Dropzone onContentProcessed={setParsedResult}/>
        {parsedResult !== undefined && parsedResult !== null ? (
          <div>
            <br/>
            <br/>
            <br/>
            <BondDisplayComponent result={parsedResult}/>
          </div>
        ) : (
          <p></p>
        )}
        <br/>
        <br/>
        <br/>
      </div>
      <FooterComponent/>
    </div>
  );
}

export default App;
